module.exports = __webpack_public_path__ + "img/mbslogo.1fd9294b.png";